import { createAction, props } from '@ngrx/store';

export const connectToWebsocket = createAction('[Websocket] connect to websocket');
export const connectToWebsocketSuccess = createAction('[Websocket] connect to websocket success');
export const websocketFailure = createAction('[Websocket] connect to websocket failure', props<{ error: string }>());
export const websocketClosed = createAction('[Websocket] websocket closed');

export const authenticate = createAction('[Websocket] authenticate', props<{ accessToken: string; isRetry?: boolean }>());
export const authenticateRejected = createAction('[Websocket] authenticate rejected');
export const authenticateSuccess = createAction('[Websocket] authenticate success');
export const authenticateFailure = createAction('[Websocket] authenticate failure', props<{ error: string }>());

export const reconnectToWebsocketIsSafe = createAction('[Websocket] reconnect to websocket is safe');

export const websocketConnectionLost = createAction('[Websocket] websocket connection lost');
export const showConnectionLostOverlay = createAction('[Websocket] show connection lost overlay');
export const dismissConnectionLostOverlay = createAction('[Websocket] dismiss connection lost overlay');
